/** Slugs métiers reconnus pour les URLs courtes /{slug} et /{locale}/{slug}. */
import { METIER_SLUGS } from '../seo/metierSeoBlocks';

export const BOOKING_METIER_SLUG_SET = new Set<string>(METIER_SLUGS);

export function isBookingMetierSlug(segment: string | undefined): segment is string {
  return Boolean(segment && BOOKING_METIER_SLUG_SET.has(segment));
}
